import { Stack, Typography } from "@mui/material";
import {useGetMe} from "../../../hooks";
import {currencyFormatter} from "../../../helpers/currencyFormat";
import { useMemo } from "react";
import ProfileCard from "./ProfileCard";
import { formatDate } from "../../../helpers/formatDate";

const ProfileICFTerms = () => {
  const { data: me } = useGetMe();
  const {
    amount,
    actualFundedAmount,
    incomeRate,
    fundedAt
  } = me?.fundingApplications?.[0] || {};

  const terms = useMemo(() => [
    {
      label: "Date Funded",
      value: fundedAt ? formatDate(new Date(fundedAt), 'short') : "N/A",
    },
    {
      label: "Funded Amount",
      value: (actualFundedAmount || actualFundedAmount === 0) ? currencyFormatter(actualFundedAmount) : amount ? currencyFormatter(amount) : "N/A",
    },
    {
      label: "Repayment Cap",
      value: (actualFundedAmount || actualFundedAmount === 0) ? currencyFormatter(1.9 * actualFundedAmount) : amount ? currencyFormatter(1.9 * amount) : "N/A",
    },
    {
      label: "Term",
      value: '72 months' // effectiveTerm ? `${effectiveTerm} months` : "N/A",
    },
    {
      label: "Maximum APR",
      value: "18.90%",
    },
    {
      label: "% of income share", // ! waiting for BE
      value: incomeRate ? `${incomeRate.toFixed(2)}%` : "N/A", //(100 - ((startingSalary / 12) * 0.0075 * amount) / 1000).toFixed(2) + '%' : "N/A",
    }
  ], [amount, incomeRate, fundedAt, actualFundedAmount]);

  return <ProfileCard title="ICF Terms" maxWidth="900px">
    {terms.map((term) => (
      <Stack key={term.label} direction="row" spacing={2} width="100%" justifyContent="space-between" alignItems="center" sx={{ borderBottom: '1px solid #EDF0FC', paddingBottom: '10px'}}>
        <Typography variant="label1">{term.label}</Typography>
        <Typography variant="data">{term.value}</Typography>
      </Stack>
    ))}
  </ProfileCard>;
};

export default ProfileICFTerms; 